var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goApp"},[_c('img',{staticClass:"goApp-logo",attrs:{"src":require("@/assets/global/app-logo.png")},on:{"click":_vm.goTo}}),_c('button',{staticClass:"goApp-btn",on:{"click":_vm.goTo}},[_vm._v(_vm._s(_vm.btnText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }